export default "__VITE_ASSET__D9$I58Ce__"